import { ErrorBoundary } from 'react-error-boundary';
import { CurrentCtxInitializer } from './current-ctx.provider';
import { MsalProvider } from '@azure/msal-react';
import { ConfigProvider } from 'antd';
import viVN from 'antd/es/locale/vi_VN';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/configs/azure.config';
import { ErrorPage } from '@/pages/error.page';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import ModalProvider from './modal.provider';
import { store } from '@/redux/store';
import { AuthProvider } from './auth.provider';
import { NotificationProvider } from './notification.provider';
import { AccessPermissionProvider } from './access-permission.provider';
import DrawerProvider from './drawer.provider';

const msalInstance = new PublicClientApplication(msalConfig);

export function FullProvider({ children }: { children: ReactNode }) {
  return (
    <CurrentCtxInitializer>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <MsalProvider instance={msalInstance}>
          <ConfigProvider locale={viVN}>
            <Provider store={store}>
              <NotificationProvider>
                <ModalProvider>
                  <DrawerProvider>
                    <AuthProvider>
                      <AccessPermissionProvider>
                        {children}
                      </AccessPermissionProvider>
                    </AuthProvider>
                  </DrawerProvider>
                </ModalProvider>
              </NotificationProvider>
            </Provider>
          </ConfigProvider>
        </MsalProvider>
      </ErrorBoundary>
    </CurrentCtxInitializer>
  );
}
